export default __webpack_public_path__ + "static/media/quicksand-bold.4c3d2317.ttf";